module.exports = __webpack_public_path__ + "static/media/innocent-3.4ce500db.png";